import {VIEWED_PRODUCT_KEY} from '@/lib/constants';

export const updateViewedProductInLocalStorage = (sku: string) => {
    if (!sku) return;

    const viewedProductStorage = localStorage.getItem(VIEWED_PRODUCT_KEY);
    const skusArray = viewedProductStorage ? JSON.parse(viewedProductStorage) : [];
    const existingProductIndex = skusArray.findIndex((item: string) => item === sku);

    if (existingProductIndex !== -1) return;
    if (skusArray.length >= 20) {
        skusArray.pop();
    }
    skusArray.unshift(sku);

    const skusArrayJson = JSON.stringify(skusArray);
    localStorage.setItem(VIEWED_PRODUCT_KEY, skusArrayJson);
};
